import { combineBytes, bin2string } from "../utils";

export function handleBatteryPacket(id, payload, battery, bleEventDispatcher) {
	// ID: 0x351 - Charged and Discharged parameters
	if (id == 0x351) {
		const maxChargeVoltage = combineBytes(payload[1], payload[0]) / 10;
		const chargeCurrent = combineBytes(payload[3], payload[2]) / 10;
		const dischargeCurrent = combineBytes(payload[5], payload[4]) / 10;
		const dischargeVoltage = combineBytes(payload[7], payload[6]) / 10;
		return true;
	}

	// ID: 0x355 - State of charge, State of health
	if (id === 0x355) {
		const soc = combineBytes(payload[1], payload[0]);
		const soh = combineBytes(payload[3], payload[2]);
		battery.soc = soc;
		battery.soh = soh;
		return true;
	}

	// ID 0x356: Voltage, Current, Temp
	if (id === 0x356) {
		const voltage = combineBytes(payload[1], payload[0]) / 100;
		const current = combineBytes(payload[3], payload[2]) / 10;
		const power = voltage * current;
		const temp = combineBytes(payload[5], payload[4]) / 10;

		battery.voltage = voltage;
		battery.current = current;
		battery.power = power;
		battery.temp = temp;

		const batterySOC = battery.soc;
		const batteryCapacity = battery.capacity;

		if (current < 0) {
			const hoursToEmpty = ((batterySOC / 100) * batteryCapacity) / -current;
			battery.status = "Empty in " + Math.floor(hoursToEmpty) + "h " + Math.floor((hoursToEmpty % 1) * 60) + "m";
		}

		if (current > 0) {
			const hoursToFull = (((100 - batterySOC) / 100) * batteryCapacity) / current;
			battery.status = "Full in " + Math.floor(hoursToFull) + "h " + Math.floor((hoursToFull % 1) * 60) + "m";
		}

		if (current === 0) {
			battery.status = "Idle";
		}

		bleEventDispatcher.emit("battery", battery);
		return true;
	}

	// ID 0x359 - Protection & Alarm flags - Never seen this in the wild

	// ID: 0x35A - Various Alarm flags
	if (id == 0x35a) {
		return true;
	}

	// ID 0x35E - Name of BMS ASCII
	if (id == 0x35e) {
		const batteryName = bin2string(payload);
		return true;
	}

	// ID: 0x35F - Type ID, Software Version, Available Capacity, Product ID Hardware Config
	if (id === 0x35f) {
		const typeID = combineBytes(payload[1], payload[0]) + " ";
		const softwareVersion = combineBytes(payload[3], payload[2]) + " ";
		battery.capacity = combineBytes(payload[5], payload[4]) + " ";
		const productIDHardwareConfig = combineBytes(payload[7], payload[6]) + " ";

		return true;
	}

	// ID: 0x370 - BMS Name
	if (id == 0x370) {
		const bmsName = bin2string(payload);
		return true;
	}

	// ID: 0x371 - Actual Max Cell Temp ID, Min Cell Temp ID, Max Cell V ID, Min Cell ID - Always empty
	if (id == 0x371) {
		const maxCellTempID = combineBytes(payload[1], payload[0]) + " ";
		const minCellTempID = combineBytes(payload[3], payload[2]) + " ";
		const maxCellVoltageID = combineBytes(payload[5], payload[4]) + " ";
		const minCellVoltageID = combineBytes(payload[7], payload[6]) + " ";
		return true;
	}

	// ID: 0x373 - Cell voltages (High and Low)
	if (id == 0x373) return true;

	// ID: 0x374 - Min cell voltage ID [ASCII] ( Victron )
	if (id == 0x374) {
		const minCellVoltageID = bin2string(payload);
		return true;
	}

	// ID: 0x375 - Max cell voltage ID [ASCII] ( Victron )
	if (id == 0x375) {
		const maxCellVoltageID = bin2string(payload);
		return true;
	}

	// ID: 0x376 - Min cell temperature ID [ASCII] ( Victron )
	if (id == 0x376) {
		const minCellTempID = bin2string(payload);
		return true;
	}

	// ID: 0x377 -  Max cell temperature ID [ASCII] ( Victron )
	if (id == 0x377) {
		const maxCellTempID = bin2string(payload);
		return true;
	}

	// ID: 0x379 - Capacity (Ah) when installed
	if (id == 0x379) {
		const installedCapacity = combineBytes(payload[1], payload[0]) + " ";
		return true;
	}

	return false;
}
